import { renderInDocument } from '@spotahome/soyuz/client';

import StaticPageContainer from './static-page';

renderInDocument(StaticPageContainer);
